import PopupNew from './popup-new';

const GALLERY_CARD_CLASS = 'gallery-card';

const getPopupData = () =>
  Array.from(document.querySelectorAll(`.${GALLERY_CARD_CLASS}`)).map((card, index) => {
    return {
      clickItem: card,
      image: card.querySelector(`.${GALLERY_CARD_CLASS}__image`).getAttribute('src'),
      video: card.dataset.videoSrc || null,
      type: card.dataset.videoSrc ? PopupNew.TYPES.VIDEO : PopupNew.TYPES.IMAGE,
      title: card.querySelector(`.${GALLERY_CARD_CLASS}__info-title`)?.textContent,
      text: card.querySelector(`.${GALLERY_CARD_CLASS}__info-date`)?.textContent,
      index: index
    };
  });

const GalleryNewComponent = () => {
  if (
    document.querySelector(`.${PopupNew.CLASSES.POPUP}`) &&
    document.querySelector(`.${GALLERY_CARD_CLASS}`)
  ) {
    new PopupNew(getPopupData());
  }

  const countItem = document.querySelectorAll('.gallery-new, .legacy__news, .news-new__readmore');

  if (countItem) {
    countItem.forEach((countItemBlock) => {
      const length = countItemBlock.querySelectorAll('.gallery-card, .news-card').length;

      if (length === 3) {
        countItemBlock.classList.add('count-wrapper--triple');
      } else if (length === 2) {
        countItemBlock.classList.add('count-wrapper--double');
      } else if (length === 1) {
        countItemBlock.classList.add('count-wrapper--single');
      }
    });
  }
};

export const GalleryNew = () => {
  $(document).ready(() => GalleryNewComponent());
};
